// extracted by mini-css-extract-plugin
export default {"payment-success__content":"PaymentRedirect_payment-success__content__qCGXN"};